module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "vw-scroller",
    on: {
      "touchstart": _vm.touchStart,
      "touchmove": _vm.touchMove,
      "touchend": _vm.touchEnd,
      "scroll": _vm.scrollingWatcher
    }
  }, [_c('div', {
    staticClass: "vw-scroller-tips",
    staticStyle: {
      "height": "0"
    }
  }, [_vm._v(_vm._s(_vm.innerText))]), _vm._v(" "), _c('div', {
    staticClass: "vw-scroller-content"
  }, [_vm._t("default")], true), _vm._v(" "), (_vm.options.infiniteFun) ? _c('div', {
    staticClass: "vw-scroller-bottom"
  }, [_vm._v(_vm._s(_vm.options.bottomDesc || 'Load more'))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-3fd45604!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/scroller/scroller.vue
// module id = 232
// module chunks = 0